import { useContext, useEffect, useState } from "react";
import { Environment } from "@hopper-b2b/utilities";
import clsx from "clsx";
import { UserContext } from "../../App";
import styles from "./styles.module.scss";

const ImpersonationBanner = () => {
  const [showImpersonation, setShowImpersonation] = useState(true);
  const { sessionInfo } = useContext(UserContext);
  const environment: Environment = import.meta.env.MODE as Environment;
  const dashboardLink =
    environment === Environment.production
      ? "https://b2bdashboard.portal.hopper.com/tenant/nubank/user/"
      : "https://b2bdashboard.portal.staging.hopper.com/tenant/nubank/user/";

  useEffect(() => {
    if (environment === Environment.staging) {
      const keyPressHandler = (e: KeyboardEvent) => {
        const isCmdOrCtrl = e.metaKey;

        if (isCmdOrCtrl && e.key === "i") {
          e.preventDefault();
          setShowImpersonation(!showImpersonation);
        }
      };

      window.addEventListener("keydown", keyPressHandler);
      return () => {
        window.removeEventListener("keydown", keyPressHandler);
      };
    }
  }, [environment, showImpersonation]);

  return showImpersonation ? (
    <div className={clsx(styles.ImpersonationBanner, "is-impersonation")}>
      <p>
        Please note you are impersonating{" "}
        <a
          href={dashboardLink + sessionInfo.hopperUserId}
          target="_blank"
          rel="noreferrer"
        >
          {sessionInfo.userInfoResponse.name}
        </a>{" "}
        in {environment}.
        {environment === Environment.staging ? (
          <>
            {" "}
            <br />
            show/hide this banner with <code>cmd+i</code>.
          </>
        ) : null}
      </p>
    </div>
  ) : null;
};

export default ImpersonationBanner;
